import { LicenseId } from 'src/api/dto/organization/licenseId';

const PricePackageLabels = new Map<LicenseId, string>();
PricePackageLabels.set('FREE', 'Free');
PricePackageLabels.set('STARTER', 'Starter');
PricePackageLabels.set('BASIS', 'Basis');
PricePackageLabels.set('LARGE', 'NaN');

export default PricePackageLabels;
